import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/scroll";

const WhatsAppFloat = () => (
  <motion.a
    data-testid="floating-whatsapp-button"
    href={waLink("Hola Fumiga, quiero cotizar aplicación con dron para mis hectáreas en Santa Cruz.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Cotizar por WhatsApp"
    className="fixed bottom-6 right-6 z-50 relative flex items-center justify-center w-14 h-14 rounded-full bg-[#FFB000] text-[#151A1F] shadow-[0_8px_30px_rgba(255,176,0,0.35)] pulse-ring"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 2.2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
  >
    <MessageCircle size={26} strokeWidth={2.2} />
  </motion.a>
);

export default WhatsAppFloat;
